module.exports = __webpack_public_path__ + "static/media/Flaticon.0fd625a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flaticons/Flaticon.svg
// module id = 384
// module chunks = 0